import { createSelector } from 'reselect';
import { type AuthParams } from '../types/AuthParams';
import { type StoreState } from '../types/StoreState';
import { type WidgetMeta, type TopProps } from '../types/WidgetProps';

const noop = () => undefined;

export const selectTopProps = (state: StoreState): TopProps => {
  return state.topProps;
};
export const selectMeta = (state: StoreState): WidgetMeta => state.topProps.meta;
export const selectAppDefId = (state: StoreState): string => state.topProps.meta.appDefId;
export const selectAppInstanceId = (state: StoreState): string => state.topProps.meta.appInstanceId;
export const selectCurrency = (state: StoreState): string => state.topProps.currency;
export const selectOnClick = createSelector(selectTopProps, (topProps) => {
  if (topProps.demoMode) {
    return () => {
      topProps.onClick();
      return { canceled: true };
    };
  }
  return topProps.onClick;
});

export const selectOnShippingContactSelected = (state: StoreState) => state.topProps.onShippingContactSelected;
export const selectOnPaymentAuthorized = (state: StoreState) => state.topProps.onPaymentAuthorized;
export const selectOnPaymentAuthorizedInit = (state: StoreState) => state.topProps.onPaymentAuthorizedInit;
export const selectOnCancel = (state: StoreState) => state.topProps.onCancel ?? noop;

export const selectAuthParams = createSelector(
  selectTopProps,
  (topProps): AuthParams => ({
    appInstance: topProps.meta.appInstance,
    revalidateAppInstance: topProps.revalidateAppInstance,
  }),
);
